import React from 'react';
import './index.css';
import styled from '@emotion/styled';
import { useSearchParams } from 'react-router-dom';
import { UsersTab } from './UsersTab';
import { RolesTab } from './RolesTab';

const NavLink = styled.span`
  color: ${(props) => props.theme.colors.primaryTextColor};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  };
  &.active {
    color: ${(props) => props.theme.colors.primaryColor};
  };
`;

export default function UsersAndRolesPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get('tab');
  const handleTabChange = (tab:string) => {
    searchParams.set('tab', tab);
    searchParams.delete('page');
    setSearchParams(searchParams);
  };
  return (
    <div className='users-and-roles-wrapper'>
      <div className='h-post-m users-and-roles-title'>
        <NavLink onClick={()=>{handleTabChange('users');}} className={currentTab !== 'roles' && 'active'}>Користувачі</NavLink> і <NavLink onClick={()=>{handleTabChange('roles');}} className={currentTab === 'roles' && 'active'}>ролі</NavLink>
      </div>
      {currentTab !== 'roles' ? <UsersTab /> : <RolesTab />}
    </div>
  );
}

